import React from "react";
import { AccountSettings } from "./AccountSettings";

export const SettingsView = () => {
  return (
    <div className="space-y-8">
      <AccountSettings />
    </div>
  );
};
